export default  {
  'abstract': [ 'not-at-all', 'slightly', 'moderately', 'very', 'extremely' ],
  'agreement': [ 'strongly-disagree', 'disagree', 'neutral', 'agree', 'strongly-agree' ],
  'frequency': [ 'never', 'rarely', 'sometimes', 'often', 'always' ],
  'satisfaction': [ 'very-dissatisfied', 'dissatisfied', 'neutral', 'satisfied', 'very-satisfied' ],
  'happiness': [ 'very-unhappy', 'unhappy', 'neutral', 'happy', 'very-happy' ],
  'positivity': [ 'very-negative', 'negative', 'neutral', 'positive', 'very-positive' ],
  'likelihood': [ 'very-unlikely', 'unlikely', 'neutral', 'likely', 'very-likely' ],
  'poor-to-good': [ 'very-poor', 'poor', 'fair', 'good', 'very-good' ],
  'terrible-to-excellent': [ 'terrible', 'bad', 'okay', 'good', 'excellent' ],
  'difficulty': [ 'very-easy', 'easy', 'neutral', 'difficult', 'very-difficult' ],
  'speed': [ 'very-slow', 'slow', 'neutral', 'fast', 'very-fast' ],
  'size': [ 'very-small', 'small', 'medium', 'large', 'very-large' ]
}
